import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const CHIP_CLASS_NAME = 'Chip';
export const CHIP_CLASS_SLOTS = ['root', 'deleteIcon', 'iconWrapper'] as const;

export type ChipClassSlot = (typeof CHIP_CLASS_SLOTS)[number];

export interface ChipClasses {
	root: string;
	deleteIcon: string;
	iconWrapper: string;
}

export type ChipClassKey = keyof ChipClasses;

export const getChipUtilityClass = (slot: string) =>
	generateUtilityClass(CHIP_CLASS_NAME, slot);

export const chipClasses: ChipClasses = generateUtilityClasses(
	CHIP_CLASS_NAME,
	['root', 'deleteIcon', 'iconWrapper'],
);

export default chipClasses;
